import { Grid } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useContext, useState } from 'react';
import { Input } from '../../components/forms';
import * as Yup from 'yup';
import converge from '../../assets/images/logo-converge.svg';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';
import AuthAPI from './login-api';
import { parseJwt } from '../../utils/session';
import { AppContext } from '../../app/AppContext';
import { getRecaptchaToken } from '../../lib/recaptchaV3';
import ReCaptchaNotice from '../../components/common/ReCaptchaNotice';

const DEMO_ADMIN_EMAIL =
  process.env.REACT_APP_DEMO_ADMIN_EMAIL || 'demo@chileconverge.cl';

const LoginContainer = () => {
  const { user, roles, settings } = useContext(AppContext);
  const [error, setError] = useState('');
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleFormSubmit = async ({ email, password }) => {
    setDisabled(true);
    setLoading(true);
    setError('');
    
    try {
      const normalizedEmail = email ? email.trim().toLowerCase() : '';
      const isDemoAdmin = normalizedEmail === DEMO_ADMIN_EMAIL.toLowerCase();
      const recaptchaToken = isDemoAdmin ? undefined : await getRecaptchaToken('login');
      if (!isDemoAdmin) {
        console.log('reCAPTCHA token generado:', recaptchaToken);
        console.log('Token length:', recaptchaToken?.length);
      }
      
      const payload = { 
        email, 
        password, 
        recaptchaToken, 
        recaptchaAction: 'login' 
      };
      console.log('Payload enviado al backend:', payload);
      
      AuthAPI.login(payload)
        .then((response) => {
          const { token } = response.data;
          const newUser = parseJwt(token);
          user.actions.setUser(newUser);
          window.sessionStorage.setItem('converge.token.private', token);

          AuthAPI.getRoles().then((res) => {
            window.sessionStorage.setItem(
              'converge.roles',
              JSON.stringify(res.data.roles)
            );
            roles.actions.setRoles(res.data.roles);
          });

          AuthAPI.getSettings().then((res) => {
            window.sessionStorage.setItem(
              'converge.settings',
              JSON.stringify(res.data)
            );
            settings.actions.setSettings(res.data);
          });

          const requestedPath = location.state && location.state.from;
          const redirectPath =
            typeof requestedPath === 'string' &&
            requestedPath.startsWith('/') &&
            !requestedPath.startsWith('//')
              ? requestedPath
              : '/usuarios';

          history.replace(redirectPath);
        })
        .catch(({ data }) => {
          console.error('Error del backend:', data);
          setError(data.message || 'Error de autenticación');
        })
        .finally(() => {
          setDisabled(false);
          setLoading(false);
        });
    } catch (recaptchaError) {
      console.error('Error de reCAPTCHA:', recaptchaError);
      setError('No pudimos validar el captcha. Intenta de nuevo.');
      setDisabled(false);
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Grid container className="login-container__content">
        {/* credential secction */}
        <Grid item xs={12} sm={6} md={4} className="card-login">
          <div className="card-login__image">
            <img src={converge} alt="ChileConverge" />
          </div>
          {error && <Alert type="error">{error}</Alert>}
          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={Yup.object({
              email: Yup.string()
                .email('Formato de email incorrecto')
                .required('Ingrese su email'),
              password: Yup.string().required('Ingrese la contraseña'),
            })}
            onSubmit={handleFormSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="mt-8">
                <span>
                  <strong>Ingreso administrador</strong>
                </span>
                <Input name="email" type="text" label="ingresa tu email" />
                <Input
                  name="password"
                  label="ingrese contraseña"
                  type="password"
                />
                <Button
                  className="button"
                  loading={loading}
                  type="submit"
                  widthFull
                  disabled={disabled}
                >
                  Iniciar sesión
                </Button>
              </Form>
            )}
          </Formik>
          <ReCaptchaNotice />
        </Grid>
        {/* image */}
        <Grid item xs={12} sm={6} md={8}>
          <div className="login-container__bg-image"></div>
        </Grid>
      </Grid>
    </div>
  );
};

export default LoginContainer;
